import type { SchemaBuilderExpressionStatusProps } from "./schema-builder-expression-status.type";

import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";

import { isError } from "@/utilities/error";

import { parseExpressionFormula } from "../schema-builder-expression.helper";
import { useSchemaBuilderExpressionForm } from "../schema-builder-expression.hook";

export const SchemaBuilderExpressionStatus = ({
  name,
}: SchemaBuilderExpressionStatusProps) => {
  const { formula, isFieldTouched } = useSchemaBuilderExpressionForm({ name });
  const { ast, error } = parseExpressionFormula(formula);

  if (!isFieldTouched("formula")) return;

  if (isError(error)) {
    return (
      <Tooltip title={error.message}>
        <CloseCircleFilled className="schema-builder-expression-status-icon -error" />
      </Tooltip>
    );
  }

  if (ast) {
    return (
      <CheckCircleFilled className="schema-builder-expression-status-icon -success" />
    );
  }

  return;
};
